import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03ce2814"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "videowrap" }
const _hoisted_2 = { class: "courseInfo" }
const _hoisted_3 = {
  key: 0,
  class: "left"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "right" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "subtitle" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode()
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 正在播放 ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "disclaimer" }, " 风险提示：以上内容仅供参考，任何投资建议均不作为投资依据，不构成任何金融产品的购买、抛售或持有建议，您应自主决策，风险自担。投资有风险，入市需谨慎。 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_Player = _resolveComponent("Player")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_DownOutlined = _resolveComponent("DownOutlined")!
  const _component_a_tree = _resolveComponent("a-tree")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _directive_widthoverflowtitle = _resolveDirective("widthoverflowtitle")!
  const _directive_heightoverflowtitle = _resolveDirective("heightoverflowtitle")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["cousedetail", _ctx.theme])
  }, [
    _createVNode(_component_a_breadcrumb, null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrunmb, (item) => {
          return (_openBlock(), _createBlock(_component_a_breadcrumb_item, {
            key: item.title
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.title), 1)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      ((_ctx.videoInfo || {}).playURL || '')
        ? (_openBlock(), _createBlock(_component_Player, {
            key: 0,
            playInfo: _ctx.videoInfo,
            onPlaySatate: _ctx.isPlaying,
            definition: _ctx.definition,
            onChangeDefinition: _ctx.changeDefinition
          }, null, 8, ["playInfo", "onPlaySatate", "definition", "onChangeDefinition"]))
        : (_openBlock(), _createBlock(_component_Nodata, {
            key: 1,
            class: "nodata",
            mode: "vertical",
            customdesc: '暂无视频'
          })),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_card, {
          size: "small",
          class: "clearfix",
          bordered: false
        }, {
          title: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", {
              key: _ctx.currentLess.lessonNo || 'chouselesson'
            }, [
              _createTextVNode(_toDisplayString(_ctx.currentLess.lessonName), 1)
            ])), [
              [_directive_widthoverflowtitle, _ctx.currentLess.lessonName ? _ctx.currentLess.lessonName : '']
            ])
          ]),
          default: _withCtx(() => [
            (_ctx.introduction.coverImage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("img", {
                    src: _ctx.introduction.coverImage,
                    alt: ""
                  }, null, 8, _hoisted_4)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, _toDisplayString(_ctx.introduction.introduction), 1),
              (_ctx.introduction.shortIntroduction)
                ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_6, [
                    _createTextVNode(_toDisplayString(_ctx.introduction.shortIntroduction), 1)
                  ])), [
                    [_directive_heightoverflowtitle, _ctx.introduction.shortIntroduction]
                  ])
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_tabs, {
          type: "card",
          activeKey: _ctx.activeKey,
          "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeKey) = $event)),
          animated: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tab_pane, {
              key: "1",
              tab: "目录"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tree, {
                  class: "draggable-tree",
                  expandedKeys: _ctx.expandedKeys,
                  "onUpdate:expandedKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.expandedKeys) = $event)),
                  expandedKeysModifiers: { sync: true },
                  treeData: _ctx.treeData,
                  blockNode: true,
                  onSelect: _ctx.changenode
                }, {
                  switcherIcon: _withCtx(() => [
                    _createVNode(_component_DownOutlined)
                  ]),
                  title: _withCtx(({ key, title, index, children }) => [
                    (index+1)
                      ? _withDirectives((_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass({'active': key === _ctx.currentLess.lessonNo})
                        }, [
                          _createTextVNode(_toDisplayString(title), 1)
                        ], 2)), [
                          [_directive_widthoverflowtitle, title]
                        ])
                      : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                          _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_8, [
                            _createTextVNode(_toDisplayString(title), 1)
                          ])), [
                            [_directive_widthoverflowtitle, title]
                          ]),
                          _hoisted_9,
                          _createElementVNode("i", null, "（" + _toDisplayString((children || []).length) + "）", 1)
                        ])),
                    (key === _ctx.currentLess.lessonNo)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_10, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["playicon", {'playing': _ctx.playing}])
                          }, _hoisted_14, 2),
                          _hoisted_15
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["expandedKeys", "treeData", "onSelect"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["activeKey"])
      ])
    ]),
    _hoisted_16
  ], 2))
}